import { BenefitTransport, ImageTransport } from '@common/transports/deprecated-home-page-transport'

interface BenefitIndex {
    title: string
    image: ImageTransport
}

export const getBenefitsIndex = (benefits: Array<BenefitTransport>): Array<BenefitIndex> => {
    return (
        benefits &&
        benefits.map(benefit => ({
            title: benefit.title,
            image: benefit.image,
        }))
    )
}
